import { TaskNotice } from '@/features/contribution-kit';
import { useApp } from '@/hooks/use-app-context';
import { useOfflineSync } from '../offline-sync-context';

/** Above the item of a task that works offline: says the work is kept on the device. */
export function OfflineTaskNotice() {
  const { t } = useApp();
  const { isOnline } = useOfflineSync();
  if (isOnline) return null;
  return (
    <TaskNotice tone="info" icon="wifiOff" title={t.offline.taskNoticeTitle}>
      {t.offline.taskNoticeBody}
    </TaskNotice>
  );
}
